import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import LayoutColumn from '../components/rely/LayoutColumn.vue';
let AmLayoutColumn = class AmLayoutColumn extends Mixins(LayoutColumn) {};
AmLayoutColumn.componentName = 'AmLayoutColumn';
AmLayoutColumn = __decorate([Component({
  name: 'AmLayoutColumn'
})], AmLayoutColumn);
export default AmLayoutColumn;